import axios from '@fs/zion-axios'
import { buildUriQueryList } from '../util/StringUtil'

const BASE_RESERVATIONS_PATH = '/service/dmc/reservations'

export default () => {}

export async function createReservations(requestBody) {
  const response = await axios.post(BASE_RESERVATIONS_PATH, requestBody)
  return response
}

export async function releaseReservations(ranIds) {
  const ranIdQueryList = buildUriQueryList('ranId', ranIds)
  const response = await axios.delete(`${BASE_RESERVATIONS_PATH}?${ranIdQueryList}`)
  return response
}

export async function getReservationSupplement(ranId) {
  const response = await axios.get(`${BASE_RESERVATIONS_PATH}/${ranId}/supplement`)
  return response
}

export async function getReservationPersonIds(ranId) {
  const response = await axios.get(`${BASE_RESERVATIONS_PATH}/${ranId}/personIds`)
  return response
}

export function editReservation(ranId, body) {
  const response = axios.post(`${BASE_RESERVATIONS_PATH}/${ranId}/move-reservation`, body)
  return response
}

export async function getReservationAuthorization(authorizationId) {
  const response = await axios.get(`${BASE_RESERVATIONS_PATH}/authorizations/${authorizationId}`)
  return response
}

export function recycleRejectedTempleNames(personId) {
  return axios.put(`${BASE_RESERVATIONS_PATH}/recycle-temple-names?personId=${personId}`)
}
